import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class KaiziqLeadsConnectionService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.KAIZIQ_LEADS_CONNECTION = '/api/kaiziq-leads-connection';

        this.GET_LIST_BY_PROJECT_ID = '/get/list/project/{projectId}';
        this.GET_WHATSAPP_TEMPLATE_LIST_BY_LEADS_ID = '/get/template-list/{leadsId}';
        this.GET_WHATSAPP_NUMBER_LIST_BY_LEADS_ID = '/get/number-list/{leadsId}';
        this.GET_WHATSAPP_NUMBER_LIST_BY_PROJECT_ID = '/get/number-list/project/{projectId}';
        this.GET_LEADS_AND_WHATSAPP_NUMBER_LIST_BY_PROJECT_ID = '/get/leads/number-list/project/{projectId}';
        this.GET_PAYMENT_STATUS_BY_LEADS_ID = '/payment-status/{leadsId}';
        this.GET_WHATSAPP_TEMPLATE_LIST_BY_LEADS_ID_AND_LIMIT = '/get/template-list/{leadsId}/limit/{limit}';
        this.GET_LABELS_BY_FILTER = "/filtered/labels";
        this.CREATE = '/create';
        this.CREATE_TEMPLATE = '/create/template';
        this.DELETE_TEMPLATE = '/delete/template';
        this.UPDATE_TOKEN = '/update/token';
        this.UPDATE_ADVANCE_PROTECTION = '/update/advance-protection';
        this.DELETE = '/delete';
    }

    async getLeadsConnectionListByProjectId(projectId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_LIST_BY_PROJECT_ID;
        url = url
            .replace('{projectId}', projectId);
        try{
            const leadsConnection = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return leadsConnection;
        } catch(err) {
            console.log(err);
        }
    }

    async getTemplateListByLeadsId(leadsId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_WHATSAPP_TEMPLATE_LIST_BY_LEADS_ID;
        url = url
            .replace('{leadsId}', leadsId);
        try{
            const templateList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return templateList;
        } catch(err) {
            console.log(err);
        }
    }

    async getPhoneNumberListByLeadsId(leadsId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_WHATSAPP_NUMBER_LIST_BY_LEADS_ID;
        url = url
            .replace('{leadsId}', leadsId);
        try{
            const numberList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return numberList;
        } catch(err) {
            console.log(err);
        }
    }

    async getPhoneNumberListByProjectId(projectId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_WHATSAPP_NUMBER_LIST_BY_PROJECT_ID;
        url = url
            .replace('{projectId}', projectId);
        try{
            const numberList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return numberList;
        } catch(err) {
            console.log(err);
        }
    }

    async getLeadsAndPhoneNumberListByProjectId(projectId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_LEADS_AND_WHATSAPP_NUMBER_LIST_BY_PROJECT_ID;
        url = url
            .replace('{projectId}', projectId);
        try{
            const numberList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return numberList;
        } catch(err) {
            console.log(err);
        }
    }

    async getPaymentStatusByLeadsId(leadsId) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_PAYMENT_STATUS_BY_LEADS_ID;
        url = url
            .replace('{leadsId}', leadsId);
        try{
            const paymentStatus = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return paymentStatus;
        } catch(err) {
            console.log(err);
        }
    }

    async getTemplateListByLeadsIdWithLimit(leadsId, limit) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.GET_WHATSAPP_TEMPLATE_LIST_BY_LEADS_ID_AND_LIMIT;
        url = url
            .replace('{limit}', limit)
            .replace('{leadsId}', leadsId);
        try{
            const templateList = await this.fetch(url, {
                method: 'GET',
                retries: 10,
                retryDelay: 200
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return templateList;
        } catch(err) {
            console.log(err);
        }
    }

    async createKaiziqLeadsConnection(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.CREATE;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(leadsMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createWhatsappTemplate(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.CREATE_TEMPLATE;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(leadsMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateKaiziqLeadsConnectionToken(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.UPDATE_TOKEN;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(leadsMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateAdvanceProtection(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.UPDATE_ADVANCE_PROTECTION;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(leadsMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteKaiziqLeadsConnection(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.DELETE;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(leadsMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteWhatsappTemplate(leadsMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.KAIZIQ_LEADS_CONNECTION + this.DELETE_TEMPLATE;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(leadsMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default KaiziqLeadsConnectionService;